var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"view-container",class:{ mobile: _vm.isMobile },attrs:{"id":"section__signup"}},[_c('keep-alive',[_c('router-view',{attrs:{"user":_vm.registerForm,"id":"btn__LABSjqoaIUK2bMXGBAj5Q"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }